import { Formik, Form, Field } from 'formik';
import { useEffect, useState } from 'react';
import { NavLink, useNavigate, useParams } from 'react-router';
import * as Yup from 'yup';
import { API_BASE_URL, API_URL, DEFAULT_PER_PAGE } from '../../utilities/constants';
import PaginatedDropdown, { mapOptions } from '../../components/ui/PaginatedDropDown';
import { handleApiCall, sleep } from '../../utilities/helper';
import { useUI } from '../../context/UI';

const EditSubDepartment = () => {
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [departmentId, setdepartmentId] = useState(null);
    const [subdepartmentId, setSubDepartmentId] = useState(null);
    const [modules, setModules] = useState(null);
    const [showPassword, setShowPassword] = useState(false);

    const [data, setData] = useState(null);
    const { id } = useParams();

    const {
        setSegmentTitle,
        addToastMessage,
        addNotification,
        setNewNotification
    } = useUI();

    const [initialValues, setInitialValues] = useState({
        departmentName: "",
        departmentId: null,
        modules: [],
    });
    const validationSchema = Yup.object().shape({
        departmentName: Yup.string().required('Department Name is required'),
    });

    const fetchSubDepartmentById = async (id) => {
        setLoading(true);
        try {
            const response = await handleApiCall(API_BASE_URL + `/api/1.0.0/sub-department/${id}`, {
                method: "GET",
            });
            if (response.responseStatus === true) {
                setData(response.data);
                setLoading(false);
            }
            else {
                setLoading(false);
            }
        } catch (e) {
            setLoading(false);
            console.log("Error:", e);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (id) fetchSubDepartmentById(id);
    }, [id]);

    useEffect(() => {
        setInitialValues({
            departmentName: data?.subDepartmentName || null,
            parentDepartmentId: data?.departmentId || null,
            departmentId: data?.department && data?.department ? {
                value: data?.department?.departmentId || null,
                label: data?.department?.departmentName || null,
            } : null,
            modules: data?.subDepartmentModules
                ? data?.subDepartmentModules.map((item) => ({
                    val: item.module?.moduleId,
                    name: item.module?.moduleName,
                }))
                : [],

        })
    }, [data])
    const handleEditSubdepartment = async (value) => {
        setLoading(true);
        try {
            const payload = {
                departmentName: value.departmentName,
                departmentId: value.departmentId.value,
                moduleIds: value.modules
                    ? value?.modules.map((item) => (typeof item === "object" ? item?.val : item))
                    : [],
            };

            const response = await handleApiCall(API_BASE_URL + `/api/1.0.0/sub-department/${id}`, {
                method: "PUT",
                body: payload,
            });

            if (response.responseStatus === true) {
                addToastMessage({
                    status: true,
                    message:
                        "Sub Department updated successfully, Thank You!",
                });
                setNewNotification(true);
                addNotification({
                    id: Date.now(),
                    message: "You have successfully updated a Sub Department!",
                    status: true,
                    archive: false,
                });
                navigate(`/subdepartments?pageNo=0&pageSize=${DEFAULT_PER_PAGE}`);
            }
            else {
                addToastMessage({
                    status: false,
                    message:
                        response?.responseDescription ||
                        "Something went wrong while updating a Subdepartment. Please try again!",
                });
            }
        } catch (e) {
            setNewNotification(true);
            // setShowNotification(true);
            addNotification({
                id: Date.now(),
                message: "Something went wrong while updating a Subdepartment.",
                status: false,
                archive: false,
            });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        setSegmentTitle("Add Subdepartment");
    }, []);

    const labelManagerFunc = (o) => `${o.firstName}  ${o.lastName}`;
    const labelSubDepartmentFunc = (o) => `${o.subDepartmentName}`;
    const labelDepartmentFunc = (o) => `${o.departmentName}`;
    const labelModuleFunc = (o) => `${o.moduleName}`;


    return (
        <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            enableReinitialize={true}
            onSubmit={handleEditSubdepartment}
        >
            {({ errors, touched, setFieldValue, values }) => (
                <Form className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-md max- mx-auto space-y-6">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div>
                            <label className="block text-sm font-medium mb-1"> Name</label>
                            <Field
                                name="departmentName"
                                type="text"
                                placeholder="Enter FX"
                                className={`w-full px-3 py-2 border rounded-md text-sm focus:outline-none focus:ring ${errors.country && touched.country
                                    ? "border-red-500 focus:ring-red-300"
                                    : "border-gray-300 focus:ring-brand-300 dark:border-gray-600"
                                    }`}
                            />
                            {errors.departmentName && touched.departmentName && (
                                <p className="text-xs text-red-500 mt-1">{errors.departmentName}</p>
                            )}
                        </div>
                        <div>
                            <label className="block text-sm font-medium mb-1">Department</label>
                            <PaginatedDropdown
                                searchkey="search"
                                datakey="records"
                                url={`${API_BASE_URL}/api/1.0.0/department?`}
                                mapOptions={(records) =>
                                    mapOptions(
                                        records,
                                        "departmentId",
                                        labelDepartmentFunc
                                    )
                                }
                                error={errors.departmentId && touched.departmentId ? errors.departmentId : ""}
                                selectedValue={values?.departmentId}
                                placeHolder='Search'
                                onChange={(v) => {
                                    setFieldValue(
                                        "departmentId",
                                        v
                                    );
                                }}
                            />
                        </div>
                    </div>
                    <div>
                        <label className="block text-sm font-medium mb-1">Module</label>
                        <PaginatedDropdown
                            searchkey="search"
                            datakey="records"
                            url={`${API_BASE_URL}/api/1.0.0/modules?`}
                            mapOptions={(records) =>
                                mapOptions(
                                    records,
                                    "moduleId",
                                    labelModuleFunc
                                )
                            }
                            selectedValue={modules}
                            placeHolder='Search'
                            onChange={async (v) => {
                                if (v) {
                                    setModules(v);
                                    const p =
                                        values.modules;
                                    const n = {
                                        val: v.value,
                                        name: v.label,
                                    };
                                    if (
                                        !p.some(
                                            (item) =>
                                                item.val ===
                                                v.value
                                        )
                                    ) {
                                        setFieldValue(
                                            "modules",
                                            [
                                                ...values.modules,
                                                n,
                                            ]
                                        );
                                    }
                                }
                                await sleep();
                                setModules(null);
                            }}
                        />
                        {values?.modules.length > 0 && (
                            <ul className="w-full py-2">
                                {values?.modules.map((p, j) => (
                                    <li
                                        key={j}
                                        data-tooltip="Click to delete the module."
                                        onClick={() => {
                                            const filtered = values?.modules.filter(
                                                (obj) => obj.val !== p.val
                                            );
                                            setFieldValue("modules", filtered);
                                        }}
                                        className="
                                            inline-block 
                                            mr-1 mb-1 
                                            px-3 py-2 
                                            text-left text-sm 
                                            rounded 
                                            leading-8 
                                            cursor-pointer 
                                            bg-gray-100 text-brand-600 
                                            hover:bg-brand-100 
                                            transition
                                          "
                                    >
                                        <div className="flex items-center justify-start gap-1">
                                            <p className="truncate w-[108px] text-xs">{p.name}</p>
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="h-4 w-4"
                                                viewBox="0 0 24 24"
                                            >
                                                <path
                                                    fill="#283f54"
                                                    d="M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Zm4.151,17.943-4.143-4.1L7.891,18,6.058,16.167l4.1-4.157L6,7.891,7.833,6.058l4.155,4.1L16.094,6l1.849,1.849-4.1,4.141L18,16.094Z"
                                                />
                                            </svg>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                    <div className="flex justify-end gap-3 pt-4">
                        <NavLink to='/sub-department'>
                            <button
                                type="reset"
                                className="px-5 py-2 rounded-lg border border-gray-400 text-gray-600 hover:bg-gray-100 dark:border-gray-600 dark:text-gray-300 dark:hover:bg-gray-700 transition"
                            >
                                Cancel
                            </button>
                        </NavLink>
                        <button
                            type="submit"
                            className="px-6 py-2 rounded-lg font-medium bg-brand-600 text-white hover:bg-brand-700 transition"
                        >
                            Submit
                        </button>
                    </div>
                </Form>
            )}
        </Formik>

    );
};

export default EditSubDepartment;


